const TabPanel = (props: { index: number; value: number; children: JSX.Element }) => {
	if (props.index === props.value) return props.children;
	return null;
};

export default TabPanel;
